import React, {Component} from 'react';

class OurStoryPage extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="page our-story-page">
        <div className="container">
          <h1 className="page-title">Our Story</h1>
          <div className="row">
            <div className="col-md-12">
              <p>Welcome to Jason’s Wine &amp; Spirits, a beloved cornerstone of the Downtown Los Angeles Fashion District for more than 40 years. Located at 828 S. Main Street, Los Angeles, CA 90014, our shop has long been a trusted spot for locals, visitors, and anyone seeking quality drinks paired with warm, knowledgeable service.</p>

              <p>Our journey began with a simple vision: to create a neighborhood store where people could discover great wines, spirits, and beers while feeling a genuine sense of community. Decades later, that mission remains at the heart of everything we do. From our beginnings as a small family-run shop to becoming one of LA’s most recognized beverage destinations, we’ve always taken pride in offering something special.</p>

              <p>Our shelves are thoughtfully curated with everything from everyday favorites to rare, unique, and hard-to-find bottles you won’t come across just anywhere. Whether you’re exploring new flavors, finding the perfect gift, stocking up for an event, or simply unwinding after a long day, our team is here to help you choose the right bottle for any occasion.</p>

              <p>Convenience is one of our hallmarks. Today, we offer fast delivery from 9 a.m. to 2 a.m., seven days a week, 365 days a year, bringing your favorite drinks straight to your home, office, or gathering. Not sure if you’re within our delivery zone? Check our website or give us a call—we’re always happy to assist.</p>

              <p>Beyond our storefront, Jason’s Wine &amp; Spirits proudly supports celebrations throughout the greater Los Angeles area. Our event catering service provides customized beverage selections for gatherings of all sizes. And for the special people in your life, we offer thoughtful gift delivery options designed to make any occasion memorable.</p>

              <p>For more than four decades, our customers have become part of our extended family. Your milestones, celebrations, and everyday moments inspire us to continue offering exceptional drinks, personalized service, and a welcoming space for all.</p>

              <p>Visit us anytime at 828 S. Main Street, call us at 213-485-9463, or order online at <a href="http://jasonsliquor.com">jasonsliquor.com</a>.</p>

              <p>Cheers to great taste, lasting traditions, and many more years of serving Los Angeles!</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default OurStoryPage;



// WEBPACK FOOTER //
// ./src/containers/our-story/OurStoryPage.js